import { isNotNullish } from './is-not-nullish';

/**
 * 값을 문자열로 변환합니다.
 * toJSON 메서드가 있으면 호출하고, 없으면 JSON.stringify를 사용합니다.
 */
function stringify(value: unknown): string {
  return (
    (value && (typeof value === 'object' || typeof value === 'function') && typeof (value as { toJSON?: unknown }).toJSON === 'function'
      ? (value as { toJSON: () => string }).toJSON()
      : JSON.stringify(value)) + ''
  );
}

/**
 * 파라미터 객체를 쿼리 문자열로 변환합니다.
 *
 * @param params 파라미터 객체
 */
export function paramsToQueryString(params: Record<string, unknown>): string;
export function paramsToQueryString(params: Record<string, unknown> | null | undefined): string | null;
export function paramsToQueryString(params: Record<string, unknown> | null | undefined): string | null {
  if (params && typeof params === 'object') {
    return Object.entries(params)
      .reduce(
        (entries, [key, value]) => {
          if (Array.isArray(value)) {
            for (const valueItem of value) {
              entries.push([key, valueItem]);
            }
          } else {
            entries.push([key, value]);
          }
          return entries;
        },
        [] as Array<[string, unknown]>
      )
      .map(([key, value]) =>
        value !== undefined ? `${encodeURIComponent(key)}=${encodeURIComponent(typeof value === 'object' ? stringify(value) : String(value))}` : null
      )
      .filter(isNotNullish)
      .join('&');
  }

  return null;
}

/**
 * 쿼리 문자열을 파라미터 객체로 변환합니다.
 *
 * @param queryString 쿼리 문자열
 */
export function queryStringToParams(queryString: string): {
  [key: string]: string | Array<string>;
};
export function queryStringToParams(queryString: string | null | undefined): { [key: string]: string | Array<string> } | null;
export function queryStringToParams(queryString: string | null | undefined): { [key: string]: string | Array<string> } | null {
  if (queryString && typeof queryString === 'string') {
    const res: { [key: string]: string | Array<string> } = {};
    const split = queryString.split('&');
    for (const part of split) {
      const equalIndex = part.indexOf('=');
      const key = decodeURIComponent(part.slice(0, equalIndex));
      const value = decodeURIComponent(part.slice(equalIndex + 1));
      const oldValue = res[key];
      res[key] = oldValue == null ? value : typeof oldValue === 'string' ? [oldValue, value] : oldValue.concat(value);
    }
    return res;
  }

  return null;
}
